import { Image } from '@jfs/ui-new'
import React, { useEffect, useState } from 'react'
import { Animated } from 'react-native'

export const AnimatedIcon = ({
  source,
  width,
  height,
  top,
  left,
  moveInAnimation,
  moveOutAnimation,
  basketHeight,
}: any) => {
  const [animatedValue] = useState<any>(new Animated.Value(0))
  const animate = {
    transform: [
      {
        translateY: animatedValue.interpolate({
          inputRange: [0, 1],
          outputRange: [basketHeight - top - 124, 0],
        }),
      },
    ],
  }

  const startAnimation = ({ delay }: any) => {
    Animated.timing(animatedValue, {
      toValue: moveOutAnimation ? 1 : 0,
      duration: 1000,
      useNativeDriver: true,
      delay: delay ? 200 : undefined,
    }).start()
  }

  useEffect(() => {
    if (moveOutAnimation || moveInAnimation) {
      startAnimation({ delay: true })
    }
  }, [moveInAnimation, moveOutAnimation, startAnimation])
  return (
    <Animated.View style={[animate, { position: 'absolute', top: top, left: left, opacity: animatedValue }]}>
      <Image source={source} width={width} height={height} resizeMode={'center'} />
    </Animated.View>
  )
}
